import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes'
import './scripts/components/WigWizard'
import './scripts/components/ProductForm'
import './scripts/components/ProductBundleForm'
import './scripts/components/ProductImageSlideshow'
import './scripts/components/ProductCustomizer'
import './scripts/templates/cart'
// import './scripts/sections/header'
import './scripts/sections/account'
import './scripts/components/carousel'
import './scripts/components/carousel2'
import './scripts/components/gallery'
import './scripts/templates/product'
import './scripts/components/accordion'
import './scripts/components/addresses'
import './scripts/components/emptyCartProductGrid'
import './scripts/utils/redirection'
import './scripts/templates/login'
import './scripts/templates/register'
import './scripts/components/CameraResult'
import './scripts/components/ReviewsSlideshow'
import './scripts/components/DesktopMenu'
import './scripts/components/MobileMenu'
import './scripts/components/SearchForm'
import './scripts/components/HeroSlideshow'
import './scripts/components/logoCarousel'
import './scripts/components/VariantRadios'
import './scripts/components/ProductImageVerticalSlideshow'
import './scripts/components/OrderStatus'
